import { FunctionComponent, Fragment, useCallback } from 'react'
import { PlaylistTeaserProps } from './types'
import TeaserImage from './TeaserImage'
import ExtraData from './ExtraData'
import PlaylistTeaserComponents from '@components/Teaser/Playlist'
import useTracking from '@hooks/useTracking'
import { videoPlaylistClickHandler } from '@widgets/Video/hooks/tracking/eventMapper'

const {
  Catchword,
  EverythingWrapper,
  ExtraDataWrapper,
  ImageOverlayWrapper,
  ImageWrapper,
  OuterWrapper,
  TextWrapper,
  Title,
  VideoInfoBig,
} = PlaylistTeaserComponents

const PlaylistTeaser: FunctionComponent<PlaylistTeaserProps> = ({
  articleId,
  image = {
    src: '/incoming/31574-v2-missing.png',
    alt: 'image not found',
  },
  video,
  title,
  catchword,
  link,
  isActive = false,
}) => {
  const trackPlaylistClick = useTracking(videoPlaylistClickHandler)

  const { src: imageSrc, alt: imageAlt, crops: imageAvailableCrops } = image

  const onClickGTM = useCallback(() => {
    trackPlaylistClick({ articleId })
  }, [articleId, trackPlaylistClick])

  const clickableProps = {
    ...link,
    onClick: onClickGTM,
  }

  return (
    <Fragment key={articleId}>
      <EverythingWrapper
        clickableProps={
          clickableProps as unknown as { href: string; target: any } & Record<
            string,
            unknown
          >
        }>
        <OuterWrapper>
          <ImageWrapper>
            <TeaserImage
              src={imageSrc}
              alt={imageAlt}
              availableCrops={imageAvailableCrops}
            />
            {isActive ? null : (
              <ImageOverlayWrapper>
                <ExtraDataWrapper>
                  <ExtraData video={video} />
                </ExtraDataWrapper>
                <VideoInfoBig />
              </ImageOverlayWrapper>
            )}
          </ImageWrapper>
          <TextWrapper>
            {catchword ? <Catchword>{catchword}</Catchword> : null}
            <Title>{title}</Title>
          </TextWrapper>
        </OuterWrapper>
      </EverythingWrapper>
    </Fragment>
  )
}

export default PlaylistTeaser
